import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-veneer',
  templateUrl: './veneer.component.html',
  styleUrls: ['./veneer.component.scss']
})
export class VeneerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
